export const valoresExibidosOffCanvasPDPs: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorStatus: '',
  separadorProdutos: '',
  separadorParceiro: '',
  separadorObservacoes: '',

  //Específicos
  statusPublicacao: 'Publicação site',
  dataPublicacao: 'Data publicação',
  statusVigencia: 'Vigência',
  statusPdp: 'Status',
  plataforma: 'Plataforma',
  faseAtual: 'Fase atual',
  idPdp: 'ID PDP',
  termoCompromisso: 'Termo de Compromisso',
  dataInicioFaseII: 'Data de Início da Fase II',
  dataInicioFaseIII: 'Data de Início da Fase III',
  demanda: 'Demanda (%)',
  instituicaoPublica: 'Inst. Pública',
  parceiroPrivadoNacional: 'Parceiro Privado Nacional',
  parceiroPrivadoInternacional: 'Parceiro Privado Internacional',
  entidadeIfa: 'Entidade IFA Base Química',
  produtosDAF: 'Produtos DAF',
};

export const headersPDPs = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'ID PDP', width: 5, key: 'idPdp' },
  { text: 'Vigência', width: 5, key: 'statusVigencia' },
  { text: 'Status', width: 5, key: 'statusPdp' },
  { text: 'Fase', width: 3, key: 'faseAtual' },
  { text: 'Plataforma', width: 5, key: 'plataforma' },
  { text: 'Demanda', width: 3, key: 'demanda' },
  { text: 'Produto(s)', width: 30, key: 'produtosDAF' },
];

export const fieldObjectPDPs = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
